import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSnackbar,{attrs:{"timeout":_vm.message.timeout,"color":_vm.message.status,"top":"","right":""},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c(VBtn,_vm._b({attrs:{"dark":"","text":""},on:{"click":function($event){_vm.display = false}}},'v-btn',attrs,false),[_vm._v(" Закрыть ")])]}}]),model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }